import { render, staticRenderFns } from "./waitloading.vue?vue&type=template&id=41046c4f&scoped=true"
import script from "./waitloading.vue?vue&type=script&lang=js"
export * from "./waitloading.vue?vue&type=script&lang=js"
import style0 from "./waitloading.vue?vue&type=style&index=0&id=41046c4f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41046c4f",
  null
  
)

export default component.exports